import { motion } from "framer-motion";
import { CalendarDays, MapPin, ArrowUpRight } from "lucide-react";
import { scrollToId } from "../hooks/useLenis";

const ease = [0.16, 1, 0.3, 1];

const EVENTS = [
  {
    id: "preventica-lyon",
    tag: "Salon international · Suivi RisQZero",
    title: "Préventica Lyon 2026",
    date: "6 – 8 octobre 2026",
    place: "Eurexpo, Lyon · France",
    text: "Le rendez-vous européen de la santé, sécurité et qualité de vie au travail : 550 exposants, 180 conférences. RisQZero y suit les innovations HSE pour les ramener sur le terrain africain.",
    img: "/img/event-preventica.jpg",
    accent: "bg-safety",
  },
  {
    id: "hse-days-abidjan",
    tag: "Événement · Abidjan",
    title: "HSE Days Abidjan",
    date: "Édition 2026",
    place: "Abidjan · Côte d'Ivoire",
    text: "Journées dédiées à la culture sécurité en Afrique de l'Ouest : conférences, ateliers pratiques et rencontres entre industriels, préventeurs et experts. RisQZero est au cœur de l'organisation.",
    img: "/img/event-hse-abidjan.jpg",
    accent: "bg-african",
  },
];

const EventCard = ({ e, i }) => (
  <motion.article
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1, delay: i * 0.15, ease }}
    className="group relative rounded-[2.5rem] overflow-hidden bg-forest text-white min-h-[520px] flex flex-col justify-end"
    data-testid={`event-card-${e.id}`}
  >
    <img src={e.img} alt={e.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(.16,1,.3,1)] group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-forest via-forest/70 to-forest/10" />
    <div className="absolute inset-0 grain" />
    <div className={`absolute top-6 left-6 ${e.accent} text-white text-[0.65rem] font-bold uppercase tracking-[0.22em] rounded-full px-4 py-2`}>{e.tag}</div>
    <div className="relative p-8 lg:p-10">
      <h3 className="font-heading font-extrabold text-3xl lg:text-4xl leading-tight">{e.title}</h3>
      <div className="mt-4 flex flex-wrap gap-x-6 gap-y-2 text-sm text-gold font-semibold">
        <span className="inline-flex items-center gap-2"><CalendarDays className="w-4 h-4" /> {e.date}</span>
        <span className="inline-flex items-center gap-2"><MapPin className="w-4 h-4" /> {e.place}</span>
      </div>
      <p className="mt-5 text-white/75 text-sm leading-relaxed max-w-lg">{e.text}</p>
    </div>
  </motion.article>
);

export const Events = () => (
  <section id="evenements" className="relative bg-white py-24 lg:py-32 overflow-hidden" data-testid="events-section">
    <div className="absolute inset-0 dots opacity-50" />
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-14">
        <div className="lg:col-span-7">
          <p className="eyebrow mb-5">Événements</p>
          <h2 className="font-heading font-extrabold text-forest text-3xl sm:text-4xl lg:text-5xl leading-[1.02] tracking-tight">
            Là où la prévention <span className="font-accent font-normal text-african">se rencontre.</span>
          </h2>
        </div>
        <div className="lg:col-span-5 flex lg:justify-end">
          <button onClick={() => scrollToId("contact")} data-testid="events-cta" className="group inline-flex items-center gap-2 text-sm font-bold text-forest border-b-2 border-african pb-1">
            Organiser un Safety Day avec nous
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:rotate-45" />
          </button>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-6">
        {EVENTS.map((e, i) => <EventCard key={e.id} e={e} i={i} />)}
      </div>
    </div>
  </section>
);
